<template>
  <div class="c-cbr-Logo-outer">
    <img
      v-if="src"
      :src="src"
      :class="['c-cbr-Logo-logo', positionClass, $style.logo]"
      :alt="`Logo of ${identifier}`"
      @click="goHome()">
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  props: {
    src: {
      type: String,
      required: true
    },
    position: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState('config', ['identifier']),
    positionClass() {
      return `is-${this.position}`
    }
  },
  methods: {
    goHome() {
      this.$router.push(`/m/` + this.identifier)
    },
  }
}
</script>

<style module>
.logo {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// client/components/CbrLogo.vue